import { createUseStyles } from 'react-jss';

import {
  AbsoluteBlackColors,
  AbsoluteWhiteColors,
} from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    /**
     * Pinned to the viewport, not to the app's own box.
     *
     * `100vw`/`100dvh` on a statically positioned block only fills the screen
     * when the app *is* the screen. Embedded in a host page (gen.ai mounts
     * `./Embed`), the app occupies a panel, so the feed flowed inside it and was
     * clipped by `appShell`'s `overflow: hidden` — opening with its top cut off.
     *
     * `position: fixed` resolves against the viewport in both cases and is not
     * clipped by an ancestor's overflow, so the feed is full screen standalone
     * and embedded alike. Nothing above it creates a containing block:
     * `appShell` is `position: relative` with `isolation: isolate`, neither of
     * which anchors fixed descendants.
     */
    overlay: {
      position: 'fixed',
      inset: 0,
      zIndex: StackingContext.popup,
      width: '100vw',
      height: '100dvh',
      overflow: 'hidden',
    },
    shell: {
      position: 'relative',
      width: '100vw',
      height: '100dvh',
      overflow: 'hidden',
      backgroundColor: AbsoluteBlackColors.base.default,
    },
    backButton: {
      position: 'absolute',
      top: `max(${Spacings.s12}, env(safe-area-inset-top))`,
      left: Spacings.s16,
      zIndex: StackingContext.layout,
    },
    closeButton: {
      position: 'absolute',
      top: `max(${Spacings.s12}, env(safe-area-inset-top))`,
      left: Spacings.s16,
      zIndex: StackingContext.layout,
    },
    muteButton: {
      position: 'absolute',
      top: `max(${Spacings.s12}, env(safe-area-inset-top))`,
      right: Spacings.s16,
      zIndex: StackingContext.layout,
    },
    iconButton: {
      width: Spacings.s40,
      height: Spacings.s40,
      flex: `0 0 ${Spacings.s40}`,
      borderRadius: CornerRadius.circle,
      backgroundColor: Effects.alpha50,
      backdropFilter: 'blur(32px)',
      color: AbsoluteWhiteColors.base.default,
      border: [
        1,
        'solid',
        `color-mix(in srgb, ${AbsoluteWhiteColors.base.default} 20%, transparent)`,
      ],
    },
    scrollHintSlot: {
      position: 'absolute',
      left: '50%',
      bottom: `calc(${Spacings.s72} + ${Spacings.s24})`,
      transform: 'translateX(-50%)',
      zIndex: StackingContext.layout,
      pointerEvents: 'none',
    },
    hiddenFileInput: {
      display: 'none',
    },
  },
  { name: 'preset-feed' }
);

export default useStyles;
